export const filterByCategory = (valuesToFilter: string[], category: string, inverse = false) => {
  if (inverse) {
    return valuesToFilter.filter((val: any) => !(val.value.split('|')[0] === category));
  }
  return valuesToFilter.filter((val: any) => val.value.split('|')[0] === category);
};
